import { alpha } from '@material-ui/core/styles';
import { UtilsLib } from '@payface-frontends-libs/utils';
const { environmentConfig } = UtilsLib.Config;
function createGradient(color1, color2) {
    return `linear-gradient(to bottom, ${color1}, ${color2})`;
}
const DEVELOPMENT = {
    lighter: '#fae6c8',
    light: '#e6ca5c',
    main: '#abab00',
    dark: '#647a00',
    darker: '#335200',
};
const QA = {
    lighter: '#c8fae6',
    light: '#5ce6ca',
    main: '#00abab',
    dark: '#00647a',
    darker: '#003252',
};
const ALPHA = {
    lighter: '#e6c8fa',
    light: '#ca5ce6',
    main: '#ab00ab',
    dark: '#7a0064',
    darker: '#520032',
};
const SANDBOX = {
    lighter: '#facdc8',
    light: '#e6855c',
    main: '#ab5500',
    dark: '#7a5300',
    darker: '#524800',
};
const PRODUCTION = {
    lighter: '#faf4c8',
    light: '#dae65c',
    main: '#7bab00',
    dark: '#417a00',
    darker: '#1b5200',
};
let stagePrimary = { ...PRODUCTION };
if (environmentConfig.stageColors) {
    switch (environmentConfig.stage) {
        case 'development':
            stagePrimary = { ...DEVELOPMENT };
            break;
        case 'qa':
            stagePrimary = { ...QA };
            break;
        case 'alpha':
            stagePrimary = { ...ALPHA };
            break;
        case 'sandbox':
            stagePrimary = { ...SANDBOX };
            break;
        default:
            stagePrimary = { ...PRODUCTION };
    }
}
const PRIMARY = { ...stagePrimary };
const SECONDARY = {
    lighter: '#D6E4FF',
    light: '#84A9FF',
    main: '#3366FF',
    dark: '#1939B7',
    darker: '#091A7A',
};
const INFO = {
    lighter: '#D0F2FF',
    light: '#74CAFF',
    main: '#1890FF',
    dark: '#0C53B7',
    darker: '#04297A',
};
const SUCCESS = {
    lighter: '#E9FCD4',
    light: '#AAF27F',
    main: '#54D62C',
    dark: '#229A16',
    darker: '#08660D',
};
const WARNING = {
    lighter: '#FFF7CD',
    light: '#FFE16A',
    main: '#FFC107',
    dark: '#B78103',
    darker: '#7A4F01',
};
const ERROR = {
    lighter: '#FFE7D9',
    light: '#FFA48D',
    main: '#FF4842',
    dark: '#B72136',
    darker: '#7A0C2E',
};
const GREY = {
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24',
    5008: alpha('#919EAB', 0.08),
    50012: alpha('#919EAB', 0.12),
    50016: alpha('#919EAB', 0.16),
    50024: alpha('#919EAB', 0.24),
    50032: alpha('#919EAB', 0.32),
    50048: alpha('#919EAB', 0.48),
    50056: alpha('#919EAB', 0.56),
    50080: alpha('#919EAB', 0.8),
};
const GRADIENTS = {
    primary: createGradient(PRIMARY.light, PRIMARY.main),
    info: createGradient(INFO.light, INFO.main),
    success: createGradient(SUCCESS.light, SUCCESS.main),
    warning: createGradient(WARNING.light, WARNING.main),
    error: createGradient(ERROR.light, ERROR.main),
};
const COMMON = {
    common: { black: '#000', white: '#fff' },
    primary: { ...PRIMARY, contrastText: '#fff' },
    secondary: { ...SECONDARY, contrastText: '#fff' },
    info: { ...INFO, contrastText: '#fff' },
    success: { ...SUCCESS, contrastText: GREY[800] },
    warning: { ...WARNING, contrastText: GREY[800] },
    error: { ...ERROR, contrastText: '#fff' },
    grey: GREY,
    gradients: GRADIENTS,
    divider: GREY[50024],
    action: {
        hover: GREY[5008],
        selected: GREY[50016],
        disabled: GREY[50080],
        disabledBackground: GREY[50024],
        focus: GREY[50024],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
export const palette = {
    light: {
        ...COMMON,
        text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
        background: { paper: '#fff', default: '#fff', neutral: GREY[200] },
        action: { active: GREY[600], ...COMMON.action },
    },
    dark: {
        ...COMMON,
        text: { primary: '#fff', secondary: GREY[500], disabled: GREY[600] },
        background: { paper: GREY[800], default: GREY[900], neutral: GREY[50016] },
        action: { active: GREY[500], ...COMMON.action },
    },
};
//# sourceMappingURL=palette.js.map